__turbopack_context__.v({
  "empty-option": "select-module__WresOa__empty-option",
  "error-message": "select-module__WresOa__error-message",
  "footer": "select-module__WresOa__footer",
  "label": "select-module__WresOa__label",
  "label-disabled": "select-module__WresOa__label-disabled",
  "select": "select-module__WresOa__select",
  "wrapper": "select-module__WresOa__wrapper",
});
